import { isEmpty } from 'lodash';
import axios from '../../libs/cifra/axios';

const URL_BASE = '/solicitud_matriculas';

function contactos(idsSolicitudes, options) {
  if (!idsSolicitudes) {
    return [];
  }

  const opts = options || {};
  const defaultParams = {
    ids: idsSolicitudes,
  };
  opts.params = Object.assign(defaultParams, opts.params);

  return axios.get(`${URL_BASE}/contactos`, opts);
}

export default {
  contactos,
  async emails(idsSolicitudes, options) {
    const { data } = await contactos(idsSolicitudes, options);
    const emails = data.filter((contacto) => !isEmpty(contacto.email)).map((contacto) => (
      `${contacto.nombre} <${contacto.email}>`
    ));
    return emails;
  },
};
